import { setBrManagementUrl, setClmUrl, setCmpUrl, setEnv, setMsdUrl, setUserId } from 'reducers/appConfigReducer';
import { getAppConfig } from '../services/appconfig/getAppConfig';
import { AppConfig } from 'types';
import { AppDispatch } from 'store';
import { closeModal, openModal } from '../reducers/modalReducer';

export const fetchAppConfig = () => async (dispatch: AppDispatch) => {
  return getAppConfig()
    .then((response: AppConfig) => {
      dispatch(setClmUrl(response.clmUrl));
      dispatch(setMsdUrl(response.msdUrl));
      dispatch(setCmpUrl(response.cmpUrl));
      dispatch(setBrManagementUrl(response.brManagementUrl));
      dispatch(setUserId(response.userId));
      dispatch(setEnv(response.env));
    })
    .catch((error) => {
      dispatch(
        openModal({
          modalType: 'JBErrorModalWrapper',
          modalProps: {
            httpError: error,
            okHandler: () => {
              dispatch(closeModal());
            },
            technicalInfo: {
              title: 'Error when retrieving application configuration',
              userErrorMessage: 'An error occurred when retrieving application configuration. Please try again later.',
            },
          },
        }),
      );
      return;
    });
};
